import { apiClient } from "./apiClient.js"

export const componentConfigApi = {
    /**
     * Fetch Component Config for a given Component
     * @param {string} businessEntityId - The Business Entity ID
     * @param {string} machinePermanentId - The Machine Permanent ID
     * @param {string} componentPermanentId - The Component Permanent ID
     * @param {object} config - The application config object
     * @param {object} accessToken - The logged in user's accessToken
     * @returns {Promise} - The Component Config as a Promise
     */
    fetchComponentConfig: async (businessEntityId, machinePermanentId, componentPermanentId, config, accessToken) => {
        if (`${machinePermanentId}` == "undefined") {
            throw new Error("Machine permanent ID is undefined")
        }
        else if (`${componentPermanentId}` == 'undefined') {
            throw new Error("Component permanent ID is undefined")
        }
        const url = `${config.managementApiUrl}/businessentities/${businessEntityId}/machines/${machinePermanentId}/components/${componentPermanentId}/componentConfigs/0`
        return await apiClient(
            url,
            accessToken,
            {
                method: "GET"
            },
            async (response) => {
                return await response.json().then(
                    (result) => {
                        return result.componentConfig
                    }
                )
            }
        )
    },
    /**
     * Update Component Config
     * @param {string} businessEntityId - The Business Entity ID
     * @param {string} machinePermanentId - The Machine Permanent ID
     * @param {string} componentPermanentId - The Component Permanent ID
     * @param {object} componentConfig - The updated component config to send to the database
     * @param {object} config - The application config object
     * @param {object} accessToken - The logged in user's accessToken
     * @returns {Promise} - The update result as a Promise
     */
    updateComponentConfig: async (businessEntityId, machinePermanentId, componentPermanentId, componentConfig, config, accessToken) => {
        const url = `${config.managementApiUrl}/businessEntities/${businessEntityId}/machines/${machinePermanentId}/components/${componentPermanentId}/componentConfigs/0`
        // IMPORTANT: Note that this is PUT rather than POST.
        return await apiClient(url, accessToken, {
            method: "PUT",
            headers: {
                'clientId': '4'
            },
            body: JSON.stringify(componentConfig)
        })
    },
    fetchDeviceConfigRecord: async (businessEntityId, componentId, deviceId, config, accessToken) => {
        const url = `${config.managementApiUrl}/businessentities/${businessEntityId}/components/${componentId}/deviceconfigrecords/${deviceId}`
        return await apiClient(
            url,
            accessToken,
            {
                method: "GET"
            },
            async (response) => {
                return await response.json().then(
                    (result) => {
                        console.log("Got the following result from fetching device config record:")
                        console.log(result)
                        return result.deviceConfigRecord
                    }
                )
            }
        )
    },
    fetchDeviceConfigRecordsList: async (businessEntityId, componentId, config, accessToken) => {
        const url = `${config.managementApiUrl}/businessentities/${businessEntityId}/components/${componentId}/deviceconfigrecords`
        return await apiClient(
            url,
            accessToken,
            {
                method: "GET"
            },
            async (response) => {
                return await response.json().then(
                    (result) => {
                        console.log("Got the following result from fetching device config records list:")
                        console.log(result)
                        return result.deviceConfigRecord
                    }
                )
            }
        )
    }
}